import {
  Component,
  ContentChild,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { TranscludeDirective } from '@app/shared/directives/transclude.directive';

@Component({
  selector: 'portal-menu-context',
  templateUrl: './menu-context.component.html',
  host: {
    class: 'nav-item nav-item--context',
  },
  standalone: false,
})
export class MenuContextComponent implements OnInit {
  @ContentChild(TemplateRef)
  content?: TemplateRef<any>;

  @ContentChildren(TranscludeDirective)
  transclusions: QueryList<TranscludeDirective>;

  @Input()
  public description?: string;

  @Input()
  public heading?: string;

  constructor() {}

  ngOnInit() {}
}
